import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './HomePage1.css';

const HomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAdminOpen, setIsAdminOpen] = useState(false);

  const closeAllMenus = () => {
    setIsMenuOpen(false);
    setIsAdminOpen(false);
    document.body.classList.remove('public-menu-open');
  };

  const toggleMenu = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    setIsMenuOpen((prev) => {
      const next = !prev;

      if (next) {
        document.body.classList.add('public-menu-open');
      } else {
        document.body.classList.remove('public-menu-open');
      }

      return next;
    });

    setIsAdminOpen(false);
  };

  const toggleAdminMenu = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    setIsAdminOpen((prev) => !prev);
  };

  const goToPage = (path, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    closeAllMenus();

    setTimeout(() => {
      navigate(path);
    }, 20);
  };

  useEffect(() => {
    closeAllMenus();
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        closeAllMenus();
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.classList.remove('public-menu-open');
    };
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {isMenuOpen ? (
        <div
          className="public-menu-backdrop"
          onClick={closeAllMenus}
          role="button"
          tabIndex={0}
          aria-label="Close menu"
        />
      ) : null}

      <nav className="public-navbar">
        <div className="public-nav-brand">
          <button
            type="button"
            className="public-logo-link"
            onClick={(e) => goToPage('/', e)}
          >
            <div className="public-logo-mark">V</div>

            <div className="public-logo-text">
              <strong>Vakra</strong>
              <small>Business Platform</small>
            </div>
          </button>
        </div>

        <button
          type="button"
          className={`public-hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="public-bar"></span>
          <span className="public-bar"></span>
          <span className="public-bar"></span>
        </button>

        <ul className={`public-nav-links ${isMenuOpen ? 'active' : ''}`}>
          <li className="public-mobile-head">
            <div className="public-mobile-brand">
              <div className="public-logo-mark">V</div>

              <div>
                <strong>Vakra</strong>
                <small>Business Platform</small>
              </div>
            </div>
          </li>

          <li>
            <button
              type="button"
              className={isActive('/') ? 'public-nav-btn active' : 'public-nav-btn'}
              onClick={(e) => goToPage('/', e)}
            >
              Home
            </button>
          </li>

          <li>
            <button
              type="button"
              className={isActive('/about') ? 'public-nav-btn active' : 'public-nav-btn'}
              onClick={(e) => goToPage('/about', e)}
            >
              About Us
            </button>
          </li>

          <li>
            <button
              type="button"
              className={isActive('/contact') ? 'public-nav-btn active' : 'public-nav-btn'}
              onClick={(e) => goToPage('/contact', e)}
            >
              Contact Number
            </button>
          </li>

          <li>
            <button
              type="button"
              className={isActive('/login') ? 'public-nav-btn active' : 'public-nav-btn'}
              onClick={(e) => goToPage('/login', e)}
            >
              Login
            </button>
          </li>

          <li className={`public-admin-dropdown ${isAdminOpen ? 'open' : ''}`}>
            <button
              className="public-admin-btn"
              onClick={toggleAdminMenu}
              type="button"
            >
              <span>Admin</span>
              <span className="public-admin-arrow">{isAdminOpen ? '▴' : '▾'}</span>
            </button>

            <ul className={`public-admin-submenu ${isAdminOpen ? 'show' : ''}`}>
              <li>
                <button
                  type="button"
                  className={
                    isActive('/admin/login') ? 'public-nav-btn active' : 'public-nav-btn'
                  }
                  onClick={(e) => goToPage('/admin/login', e)}
                >
                  Admin Login
                </button>
              </li>

              <li>
                <button
                  type="button"
                  className={
                    isActive('/admin/signup') ? 'public-nav-btn active' : 'public-nav-btn'
                  }
                  onClick={(e) => goToPage('/admin/signup', e)}
                >
                  Admin Signup
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default HomePage;
